import { render, staticRenderFns } from "./DrawingHeaderUI.vue?vue&type=template&id=908c2608&scoped=true&"
import script from "./DrawingHeaderUI.vue?vue&type=script&lang=js&"
export * from "./DrawingHeaderUI.vue?vue&type=script&lang=js&"
import style0 from "./DrawingHeaderUI.vue?vue&type=style&index=0&id=908c2608&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908c2608",
  null
  
)

export default component.exports